(function () {
    "use strict";

    angular.module("angular.emlpayments")
        .filter("default", [function () {
            return function (value, def) {
                return value || def;
            };
        }]);
}());